import React from "react";
import { useTranslation } from "react-i18next";
import { FiAlertTriangle } from "react-icons/fi";
import SimpleModal from "components/Modal/SimpleModal";
import "./PlanUserMissingContractModal.scss";

const PlanUserMissingContractModal = ({
	isOpen,
	onClose,
	onAssignContract,
	canAssignContract,
}) => {
	const { t } = useTranslation();
	if (!isOpen) return null;

	return (
		<SimpleModal
			isOpen={isOpen}
			onClose={onClose}
			className="plan-user-missing-contract-modal"
		>
			<div className="plan-user-missing-contract">
				<div className="plan-user-missing-contract-icon" aria-hidden="true">
					<FiAlertTriangle />
				</div>
				<h2 className="plan-user-missing-contract-title">
					{t("plan.userMissingContractTitle")}
				</h2>
				<p className="plan-user-missing-contract-message">
					{t(
						canAssignContract
							? "plan.userMissingContractMessage"
							: "plan.userMissingContractContactMessage"
					)}
				</p>
				<div
					className={
						canAssignContract
							? "plan-user-missing-contract-actions"
							: "plan-user-missing-contract-actions plan-user-missing-contract-actions-centered"
					}
				>
					{canAssignContract ? (
						<>
							<button
								type="button"
								className="btn btn-outline-primary plan-user-missing-contract-button"
								onClick={onClose}
							>
								{t("common.cancel")}
							</button>
							<button
								type="button"
								className="btn btn-primary plan-user-missing-contract-button"
								onClick={onAssignContract}
							>
								{t("plan.userMissingContractAction")}
							</button>
						</>
					) : (
						<button
							type="button"
							className="btn btn-outline-primary plan-user-missing-contract-button"
							onClick={onClose}
						>
							{t("common.understood")}
						</button>
					)}
				</div>
			</div>
		</SimpleModal>
	);
};

export default PlanUserMissingContractModal;
